import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Scroll to top on route change for better UX */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
}
